import { useState } from "react";

export const useTypeOfWorkState = ({
  positionSeeking = "",
  driver = "",
  ownCar = "",
}) => {
  const isDriver = driver ? "yes" : "no";
  const hasCar = ownCar ? "yes" : "no";
  const initialState = {
    positionSeeking,
    driver: isDriver,
    ownCar: hasCar,
  };

  const [typeOfWorkState, setTypeOfWorkState] = useState(initialState);
  const [errors, setErrors] = useState({});

  const handleTypeWork = (key, val) => {
    setTypeOfWorkState((prevState) => ({
      ...prevState,
      [key]: val,
    }));
    setErrors({
      ...errors,
      [key]: [],
    });
  };

  return [typeOfWorkState, handleTypeWork, errors, setErrors];
};

export const typeOfWorkConstraints = {
  positionSeeking: {
    presence: {
      allowEmpty: false,
      message: "^Please enter the type of work you are looking for.",
    },
  },
};
